import { render, staticRenderFns } from "./WorkflowDisplay.vue?vue&type=template&id=0d187a19&scoped=true&"
import script from "./WorkflowDisplay.vue?vue&type=script&setup=true&lang=ts&"
export * from "./WorkflowDisplay.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./WorkflowDisplay.vue?vue&type=style&index=0&id=0d187a19&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d187a19",
  null
  
)

export default component.exports